'use strict';

module.exports = function (value) {
	if (value == null) throw new TypeError("Cannot use null or undefined");
	return value;
};



/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/motion/js-deps/~/es5-ext/object/valid-value.js
 ** module id = 69
 ** module chunks = 2
 **/